'use client';

import { useEffect } from 'react';

/**
 * 处理 URL 中的 hashtag 导航
 * 这个组件不渲染任何内容，只负责处理 URL 中的 hashtag 并滚动到对应元素
 */
export default function HashtagNavigation() {
  useEffect(() => {
    // 获取当前 URL 中的 hashtag
    const hash = window.location.hash;

    // 如果存在 hashtag
    if (hash) {
      // 移除 # 符号
      const id = hash.substring(1);

      // 查找对应 ID 的元素
      const element = document.getElementById(id);

      // 如果找到元素，滚动到该位置
      if (element) {
        // 添加一点延迟确保页面完全加载
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);

  // 这个组件不渲染任何内容
  return null;
}
